import { TourConfig } from 'components/tour/tour.types';

export const HOUSE_CHATS_ONBOARDING_TOUR_ID = 'house_chats';

export const HOUSE_CHATS_ONBOARDING_TOUR_CONFIG: TourConfig = {
  id: HOUSE_CHATS_ONBOARDING_TOUR_ID,
  version: 1,
  steps: [
    {
      target: 'house-chats-sidebar',
      title: 'Домовые чаты',
      description:
        'Здесь собраны все чаты в MAX, которые привязаны к домам вашей организации.',
      side: 'right',
      align: 'start',
    },
    {
      target: 'house-chats-status-filter',
      title: 'Кнопка «Статус»',
      description:
        'С её помощью можно отфильтровать список — оставить только подключённые чаты или только те, что пока не подключены.',
      side: 'right',
      align: 'start',
    },
    {
      target: 'house-chats-list-item',
      title: 'Чат дома',
      description:
        'Здесь открывается переписка с жителями. А если чат ещё не подключён — подскажем, что нужно сделать.',
      side: 'right',
      align: 'start',
    },
    {
      target: 'house-chats-mass-mailing',
      title: 'Массовые рассылки',
      description:
        'Здесь можно отправить одно сообщение сразу во все подключённые домовые чаты, не открывая их по очереди.',
      side: 'right',
      align: 'start',
    },
  ],
};
